import React, { useState } from "react";
import cn from "classnames";
import styles from "./SubscribeButton.module.sass";
import Subscription from "../Subscription";
import { openTypeform } from '../../utils/typeform';

/**
 * A button that transforms into a subscription form and redirects to Typeform
 * @param {SubscribeButtonProps} props
 * @returns {JSX.Element}
 */
const SubscribeButton = ({
    className,
    buttonText = "Step In Now",
    source = "default",
    inputPlaceholder = "Enter your email to start"
}) => {
    const [showSubscription, setShowSubscription] = useState(false);
    const [isRedirecting, setIsRedirecting] = useState(false);

    const handleSubscriptionSuccess = () => {
        setIsRedirecting(true);
        openTypeform(source);
    };

    return (
        <div className={cn(styles.wrapper, className)}>
            {!showSubscription && !isRedirecting && (
                <button 
                    className={cn("button", styles.button, "fadeIn")} 
                    onClick={() => setShowSubscription(true)}
                >
                    {buttonText}
                </button>
            )}
            {showSubscription && !isRedirecting && (
                <div className={cn(styles.subscriptionWrapper, "fadeInUp")}>
                    <Subscription 
                        className={styles.subscription} 
                        placeholder={inputPlaceholder}
                        onSuccess={handleSubscriptionSuccess}
                    />
                </div>
            )}
            {isRedirecting && (
                <div className={cn(styles.redirectingMessage, "fadeIn")}>
                    Opening your free health assessment...
                </div>
            )}
        </div>
    );
};

export default SubscribeButton; 